export const SET_GLOBAL_LOADER = 'SET_GLOBAL_LOADER';
